export const SiteCheckUrls = {
	siteCheck: '/api/info',
};
